import { defineMessages } from 'react-intl-next';

const _default_1: {
	genericErrorDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	genericErrorHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	genericErrorHeading: {
		id: 'company-hub.generic-error-page.heading',
		defaultMessage: "We're on it",
		description: 'Heading for the generic error page',
	},
	genericErrorDescription: {
		id: 'company-hub.generic-error-page.description',
		defaultMessage:
			'An unexpected error has occured when processing your request. Our team is working to get things back up and running.',
		description: 'Description for the generic error page',
	},
});
export default _default_1;
